// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"391":"e65868ee","453":"62f71aa6","667":"cb73cb97","821":"932524d0"}[chunkId] + ".chunk.js";
};